import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { images } from "../constants/images";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";
import { getBlogs } from "../api/utils";
import useFetch from "../api/hooks/useFetch";
import BlogStyles from "./styles/Blogs";

export default function Blogs() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const urlCategory =
    params.get("type")?.length > 0 ? params.get("type") : "All";

  // ✅ API Call
  const { apiData, isLoading, error } = useFetch(getBlogs, urlCategory);

  useEffect(() => {
    document.title =
      "Blog - Custom Software Development Insights | Plural Code";
    window.scrollTo(0, 0);
  }, []);

  // Sample blog posts data
  // const blogPosts = [
  //   {
  //     id: 1,
  //     title: "Why Off-the-Shelf Software Fails Growing Businesses",
  //     slug: "why-off-the-shelf-software-fails",
  //     excerpt:
  //       "Generic software forces you to adapt your business to their workflows. Here's why custom software is the better long-term investment for mid-sized companies.",
  //     category: "Custom Software",
  //     author: "Nishant Kumar",
  //     date: "December 15, 2024",
  //     readTime: "8 min read",
  //     image: images?.blog1 || images?.aboutUs,
  //     featured: true,
  //   },
  //   {
  //     id: 2,
  //     title: "ROI Calculator: When Does Custom Software Pay for Itself?",
  //     slug: "custom-software-roi-calculator",
  //     excerpt:
  //       "Break down the real costs of custom vs off-the-shelf software over 3-5 years. Includes calculator and framework for evaluating your specific situation.",
  //     category: "Business Strategy",
  //     author: "Nishant Kumar",
  //     date: "December 10, 2024",
  //     readTime: "10 min read",
  //     image: images?.blog2 || images?.aboutUs,
  //     featured: true,
  //   },
  //   {
  //     id: 3,
  //     title: "Mobile App vs Progressive Web App: Which One For Your Business?",
  //     slug: "mobile-app-vs-pwa",
  //     excerpt:
  //       "Native apps, cross-platform apps, or PWAs? We break down the pros, cons, costs, and use cases for each approach.",
  //     category: "Mobile Development",
  //     author: "Nishant Kumar",
  //     date: "December 5, 2024",
  //     readTime: "12 min read",
  //     image: images?.blog3 || images?.aboutUs,
  //     featured: false,
  //   },
  //   {
  //     id: 4,
  //     title: "How to Write a Software Requirements Document (With Template)",
  //     slug: "software-requirements-document-template",
  //     excerpt:
  //       "Before development starts, clarity matters. Here's our proven template for documenting requirements that actually lead to successful projects.",
  //     category: "Project Management",
  //     author: "Nishant Kumar",
  //     date: "November 28, 2024",
  //     readTime: "15 min read",
  //     image: images?.blog4 || images?.aboutUs,
  //     featured: false,
  //   },
  //   {
  //     id: 5,
  //     title: "System Integration 101: Connecting Your Business Tools",
  //     slug: "system-integration-guide",
  //     excerpt:
  //       "Your CRM, accounting software, and e-commerce platform don't talk to each other? Here's how custom integrations solve the data silo problem.",
  //     category: "Integrations",
  //     author: "Nishant Kumar",
  //     date: "November 20, 2024",
  //     readTime: "9 min read",
  //     image: images?.blog5 || images?.aboutUs,
  //     featured: false,
  //   },
  //   {
  //     id: 6,
  //     title: "5 Signs Your Business Has Outgrown Your Current Software",
  //     slug: "outgrown-software-signs",
  //     excerpt:
  //       "Manual workarounds. Feature bloat. Integration nightmares. Recognize these warning signs before they cost you serious money.",
  //     category: "Custom Software",
  //     author: "Nishant Kumar",
  //     date: "November 15, 2024",
  //     readTime: "7 min read",
  //     image: images?.blog6 || images?.aboutUs,
  //     featured: false,
  //   },
  //   {
  //     id: 7,
  //     title: "React Native vs Native Development: Real Cost Comparison",
  //     slug: "react-native-vs-native-costs",
  //     excerpt:
  //       "We built the same app twice—once in React Native, once natively. Here are the actual time and cost differences.",
  //     category: "Mobile Development",
  //     author: "Nishant Kumar",
  //     date: "November 8, 2024",
  //     readTime: "11 min read",
  //     image: images?.blog7 || images?.aboutUs,
  //     featured: false,
  //   },
  //   {
  //     id: 8,
  //     title: "Software Maintenance: Why It Matters More Than You Think",
  //     slug: "software-maintenance-importance",
  //     excerpt:
  //       "Launch isn't the finish line. Security updates, performance optimization, and feature evolution are critical for long-term success.",
  //     category: "Maintenance",
  //     author: "Nishant Kumar",
  //     date: "October 30, 2024",
  //     readTime: "8 min read",
  //     image: images?.blog8 || images?.aboutUs,
  //     featured: false,
  //   },
  // ];

  const blogPosts =
    apiData?.map((item) => ({
      id: item.id,
      slug: item.slug,
      title: item.title,
      excerpt: item.meta_description,
      category: item.categories, // backend key
      author: item.author,
      date: item.posted_at,
      readTime: "5 min read",
      image: item.banner || images?.aboutUs,
      featured: item.featured === "Yes",
    })) || [];

  // Categories
  // const categories = [
  //   "All",
  //   "Custom Software",
  //   "Mobile Development",
  //   "Business Strategy",
  //   "Integrations",
  //   "Project Management",
  //   "Maintenance",
  // ];

  const categoryList = [
    "All",
    "Software Audit Report",
    "Web Development",
    "Mobile Development",
    "Custom Business Software Development",
  ];

  // Filter posts based on category and search
  // const filteredPosts = blogPosts.filter((post) => {
  //   const matchesCategory =
  //     selectedCategory === "All" || post.category === selectedCategory;
  //   const matchesSearch =
  //     post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //     post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
  //   return matchesCategory && matchesSearch;
  // });

  // const featuredPosts = blogPosts.filter((post) => post.featured);
  const filteredPosts = blogPosts.filter((post) => {
    const matchesCategory =
      selectedCategory === "All"
        ? post
        : "" || selectedCategory === "Custom Business Software Development"
        ? post.category === "ERP Development"
        : post.category === selectedCategory;

    const matchesSearch =
      post.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.excerpt?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCategory && matchesSearch;
  });

  const featuredPosts = blogPosts.filter((post) => post.featured);

  const totalPages = Math.ceil(filteredPosts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPosts = filteredPosts.slice(startIndex, endIndex);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory, searchQuery]);

  return (
    <div className="blogs-page">
      {/* HERO SECTION - Same style as home page */}
      <section className="blogs-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">📝</span>
              <span className="badge-text">BLOG & INSIGHTS</span>
            </div>
            <h1 className="hero-title">
              Custom Software{" "}
              <span className="highlight">Development Insights</span>
            </h1>
            <p className="hero-subtitle">
              Practical advice, real-world examples, and strategic guidance for
              businesses investing in custom software solutions.
            </p>

            {/* Search Bar */}
            <div className="search-container">
              <div className="search-wrapper">
                <div className="search-icon">🔍</div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search articles, topics, or insights..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <div className="search-stats">
                  <span className="stat-count">{blogPosts.length}</span>
                  <span className="stat-label" style={{ color: "#ffd700" }}>
                    Articles Published
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CATEGORY FILTER */}
      <section className="category-filter">
        <div className="container">
          <div className="filter-wrapper">
            <div className="filter-label">
              <span className="filter-icon">🏷️</span>
              <span>Browse by Category:</span>
            </div>
            <div className="filter-buttons">
              {categoryList.map((category, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedCategory(category)}
                  className={`filter-btn ${
                    selectedCategory === category ? "active" : ""
                  }`}
                >
                  {category}
                  {category !== "All" && (
                    <span className="category-count">
                      {
                        blogPosts.filter((p) => {
                          return category ===
                            "Custom Business Software Development"
                            ? p.category === "ERP Development"
                            : p.category === category;
                        }).length
                      }
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED POSTS */}
      {/* {selectedCategory === "All" && searchQuery === "" && (
        <section className="featured-posts">
          <div className="container">
            <div className="section-header">
              <div className="section-badge">
                <span className="badge-icon">⭐</span>
                <span className="badge-text">FEATURED ARTICLES</span>
              </div>
              <h2 className="section-title">Must-Read Insights</h2>
              <p className="section-subtitle">
                Handpicked articles that deliver maximum value for business
                decision-makers
              </p>
            </div>

            <div className="featured-grid">
              {featuredPosts.map((post, index) => (
                <div
                  key={index}
                  className="featured-card"
                  onClick={() => window.open(`/blog/${post.slug}`, "_blank")}
                >
                  <div className="card-image">
                    <img src={post.image} alt={post.title} />
                    <div className="card-badge">{post.category}</div>
                  </div>
                  <div className="card-content">
                    <div className="post-meta">
                      <span className="post-date">{post.date}</span>
                      <span className="post-read-time">⏱️ {post.readTime}</span>
                    </div>
                    <h3 className="post-title">{post.title}</h3>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-footer">
                      <div className="author-info">
                        <div className="author-avatar">
                          {post.author.charAt(0)}
                        </div>
                        <div className="author-details">
                          <span className="author-name">{post.author}</span>
                          <span className="author-role">Lead Developer</span>
                        </div>
                      </div>
                      <button className="read-more-btn">
                        Read Article <span>→</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )} */}

      {/* ALL POSTS / FILTERED POSTS */}
      {/* <section className="all-posts">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              {selectedCategory === "All"
                ? "All Articles"
                : `${selectedCategory} Articles`}
              {searchQuery && ` - Search: "${searchQuery}"`}
            </h2>
            <p className="section-subtitle">
              {filteredPosts.length} article
              {filteredPosts.length !== 1 ? "s" : ""} found
            </p>
          </div>

          {filteredPosts.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3>No articles found</h3>
              <p>
                Try adjusting your search or category filter. We're constantly
                adding new content!
              </p>
              <button
                className="reset-btn"
                onClick={() => {
                  setSelectedCategory("All");
                  setSearchQuery("");
                }}
              >
                View All Articles
              </button>
            </div>
          ) : (
            <div className="posts-grid">
              {filteredPosts.map((post, index) => (
                <div
                  key={index}
                  className="post-card"
                  onClick={() => window.open(`/blog/${post.slug}`, "_blank")}
                >
                  <div className="post-image">
                    <img src={post.image} alt={post.title} />
                    <div className="category-tag">{post.category}</div>
                  </div>
                  <div className="post-content">
                    <div className="post-meta">
                      <span className="post-date">{post.date}</span>
                      <span className="dot">•</span>
                      <span className="post-read-time">{post.readTime}</span>
                    </div>
                    <h3 className="post-title">{post.title}</h3>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-footer">
                      <div className="author">
                        <div className="author-initials">
                          {post.author.charAt(0)}
                        </div>
                        <span>{post.author}</span>
                      </div>
                      <div className="read-more">
                        Read <span>→</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section> */}

      <section className="all-posts">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              {selectedCategory === "All"
                ? "All Articles"
                : `${selectedCategory} Articles`}
              {searchQuery && ` - Search: "${searchQuery}"`}
            </h2>
            <p className="section-subtitle">
              {filteredPosts.length} article
              {filteredPosts.length !== 1 ? "s" : ""} found
              {totalPages > 1 && ` • Page ${currentPage} of ${totalPages}`}
            </p>
          </div>

          {paginatedPosts.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3>No articles found</h3>
              <p>
                Try adjusting your search or category filter. We're constantly
                adding new content!
              </p>
              <button
                className="reset-btn"
                onClick={() => {
                  setSelectedCategory("All");
                  setSearchQuery("");
                }}
              >
                View All Articles
              </button>
            </div>
          ) : (
            <>
              <div className="posts-grid">
                {paginatedPosts.map((post, index) => (
                  <div
                    key={index}
                    className="post-card"
                    onClick={() => window.open(`/blogs/${post.slug}`, "_blank")}
                  >
                    <div className="post-image">
                      <img src={post.image} alt={post.title} />
                      <div className="category-tag">{post.category}</div>
                    </div>
                    <div className="post-content">
                      <div className="post-meta">
                        <span className="post-date">{post.date}</span>
                        <span className="dot">•</span>
                        <span className="post-read-time">{post.readTime}</span>
                      </div>
                      <h3 className="post-title">{post.title}</h3>
                      <p className="post-excerpt">{post.excerpt}</p>
                      <div className="post-footer">
                        <div className="author">
                          <div className="author-initials">
                            {post.author.charAt(0)}
                          </div>
                          <span>{post.author}</span>
                        </div>
                        {/* <div className="read-more">
                          Read <span>→</span>
                        </div> */}
                        <div
                          className="read-more"
                          onClick={(e) => {
                            e.stopPropagation(); // parent click se bachne ke liye
                            navigate(`/blogs/${post.slug}`);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Read <span>→</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* PAGINATION */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-5">
                  <nav>
                    <ul className="pagination">
                      {/* Prev Button */}
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPage((p) => Math.max(p - 1, 1))
                          }
                          disabled={currentPage === 1}
                        >
                          Prev
                        </button>
                      </li>

                      {/* Page Numbers */}
                      {Array.from({ length: totalPages }, (_, index) => {
                        const pageNumber = index + 1;
                        const isActive = currentPage === pageNumber;
                        return (
                          <li
                            key={index}
                            className={`page-item ${isActive ? "active" : ""}`}
                          >
                            <button
                              className="page-link"
                              style={{
                                backgroundColor: isActive
                                  ? "rgb(30, 58, 138)"
                                  : "transparent",
                                border: "none",
                                color: isActive ? "white" : "black",
                              }}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        );
                      })}

                      {/* Next Button */}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() =>
                            setCurrentPage((p) => Math.min(p + 1, totalPages))
                          }
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* NEWSLETTER SIGNUP */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-card">
            <div className="newsletter-content">
              <div className="newsletter-icon">📧</div>
              <h2>Get Custom Software Insights in Your Inbox</h2>
              <p>
                Weekly practical advice on custom software development, ROI
                analysis, and technology strategy. No fluff, just value.
              </p>
              <div className="row newsletter-form">
                <div className="col-lg-8">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="col-lg-4">
                  <button className="subscribe-btn">
                    Subscribe <span>→</span>
                  </button>
                </div>
              </div>
              <div className="newsletter-note">
                <span>🔒</span>
                <span>
                  Weekly insights. Unsubscribe anytime. No spam, ever.
                </span>
              </div>
            </div>
            <div className="newsletter-stats">
              <div className="stat-item">
                <div className="stat-number">1,200+</div>
                <div className="stat-label">Subscribers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">98%</div>
                <div className="stat-label">Positive Feedback</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">3-4</div>
                <div className="stat-label">Emails/Month</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG TOPICS */}

      {/* CTA SECTION */}
      <section className="blog-cta">
        <div className="container">
          <div className="cta-card">
            <div className="cta-content">
              <h2>Have a Specific Custom Software Question?</h2>
              <p>
                Can't find what you're looking for? Let's discuss your specific
                situation and see how custom software can transform your
                business.
              </p>
              <div className="cta-buttons">
                <button
                  className="cta-primary"
                  onClick={() =>
                    window.open(
                      "https://topmate.io/pluralcode/1677497",
                      "_blank"
                    )
                  }
                >
                  <span>Schedule Free Consultation</span>
                  <span>→</span>
                </button>
                <button
                  className="cta-secondary"
                  onClick={() => window.open("/services", "_blank")}
                >
                  <span>Explore Our Services</span>
                  <span>→</span>
                </button>
              </div>
            </div>
            <div className="cta-image">
              <div className="cta-stats">
                <div className="stat">
                  <div className="stat-value">50+</div>
                  <div className="stat-label">Case Studies</div>
                </div>
                <div className="stat">
                  <div className="stat-value">20+</div>
                  <div className="stat-label">Industries Served</div>
                </div>
                <div className="stat">
                  <div className="stat-value">24/7</div>
                  <div className="stat-label">Support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BlogStyles />
    </div>
  );
}
